import _JSXStyle from "styled-jsx/style";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import cx from 'classnames';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { TableContext } from './table-context.js';
const tableRowStyles = [".zebraStriping.jsx-3124144591:nth-child(even){background:#fbfcfd;}"];
tableRowStyles.__hash = "3124144591";
export const TableRow = _ref => {
  let {
    role,
    children,
    className,
    dataTest,
    suppressZebraStriping,
    ...rest
  } = _ref;
  const {
    suppressZebraStriping: suppressZebraStripingFromContext
  } = useContext(TableContext);
  const zebraStriping = typeof suppressZebraStriping !== 'undefined' ? !suppressZebraStriping : !suppressZebraStripingFromContext;
  return /*#__PURE__*/React.createElement("tr", _extends({
    "data-test": dataTest,
    role: role
  }, rest, {
    className: "jsx-".concat(tableRowStyles.__hash) + " " + (rest && rest.className != null && rest.className || cx(className, {
      zebraStriping
    }) || "")
  }), children, /*#__PURE__*/React.createElement(_JSXStyle, {
    id: tableRowStyles.__hash
  }, tableRowStyles));
};
TableRow.defaultProps = {
  dataTest: 'dhis2-uicore-tablerow'
};
TableRow.propTypes = {
  /** Should be `<TableCell>` or `<TableCellHead>` components */
  children: PropTypes.node,
  className: PropTypes.string,
  dataTest: PropTypes.string,
  role: PropTypes.string,

  /** Disables the default row striping for this row */
  suppressZebraStriping: PropTypes.bool
};